// extracted by mini-css-extract-plugin
export default {"gridContainer":"style_gridContainer__bfoYq","singleImg":"style_singleImg__NsSiy","borderGradient":"style_borderGradient__N2yEw"};